// src/components/admin/AboutUsEditor.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/aboutus.css';

function AboutUsEditor({ aboutUs, onUpdate, salonId, onSave, saving, savedMessage, onPreview }) {
  const [aboutUsContent, setAboutUsContent] = useState('');
  const [characterCount, setCharacterCount] = useState(0);
  const [error, setError] = useState('');
  
  useEffect(() => {
    console.log('AboutUs prop received:', aboutUs, 'Type:', typeof aboutUs);
    
    if (typeof aboutUs === 'string') {
      setAboutUsContent(aboutUs);
      setCharacterCount(aboutUs.length);
    } else {
      setAboutUsContent('');
      setCharacterCount(0);
    }
  }, [aboutUs]);
  
  const validateContent = (content) => {
    if (!content || content.trim() === '') {
      setError('About Us Text is mandatory. Please fill in this field.');
      return false;
    } else {
      setError('');
      return true;
    }
  };

  const handleChange = (e) => {
    const newContent = e.target.value;
    console.log('AboutUs content changed to:', newContent);
    setAboutUsContent(newContent);
    setCharacterCount(newContent.length);
    validateContent(newContent);
    onUpdate(newContent);
  };

  const handleBlur = () => {
    validateContent(aboutUsContent);
  };

  const getCharacterCountClass = () => {
    if (characterCount > 1000) return 'error';
    if (characterCount > 800) return 'warning';
    return '';
  };
  
  return (
    <div className="about-us-editor">
      <div className="editor-page-header">
        <h2>About Us</h2>
        <div className="editor-page-actions">
          {savedMessage && <span className={`editor-save-msg${savedMessage.toLowerCase().includes('error') ? ' error' : ''}`}>{savedMessage}</span>}
          <button className="page-action-btn page-action-preview" type="button" onClick={onPreview}>Live Preview</button>
          <button className="page-action-btn page-action-save" type="button" onClick={onSave} disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button>
        </div>
      </div>
      <p className="editor-info">Share your salon's story and mission here.</p>
      
      <div className="form-group">
        <label htmlFor="aboutUsTextarea">
          About Us Text <span className="required-asterisk">*</span>
        </label>
        <textarea
          id="aboutUsTextarea"
          value={aboutUsContent}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Tell your clients about your salon's story, mission, and team..."
          className={`about-us-textarea ${error ? 'input-error' : ''}`}
          rows={10}
        />
        {error && <span className="error-message">{error}</span>}
        <div className={`character-count ${getCharacterCountClass()}`}>
          {characterCount} characters {characterCount > 1000 && '(recommended maximum: 1000)'}
        </div>
      </div>
      
      <div className="preview-section">
        <h3>Preview</h3>
        <div className="preview-content">
          {aboutUsContent ? (
            <p>{aboutUsContent}</p>
          ) : (
            <p style={{ fontStyle: 'italic', color: 'var(--medium-gray)' }}>
              Your about us content will appear here...
            </p>
          )}
        </div>
      </div>
      
      <div className="editor-tips">
        <h3>Writing Tips</h3>
        <ul>
          <li>Share your salon's history and mission</li>
          <li>Highlight your team's expertise and credentials</li>
          <li>Describe what makes your salon unique</li>
          <li>Include your salon's values and commitment to clients</li>
          <li>Keep it concise but engaging (aim for 200-500 words)</li>
          <li>Use a friendly, welcoming tone</li>
        </ul>
      </div>
    </div>
  );
}

export default AboutUsEditor;